import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty } from "lodash";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import DeleteModal from '../../../components/Common/DeleteModal';
import MultiSelectOption from "../MultiSelectOption";
import "jspdf-autotable";
import * as XLSX from 'xlsx';

import {
  addRecipes as onAddRecipes,
  updateRecipes as onUpdateRecipes,
  getRecipes as onGetRecipes,
  deleteRecipes as onDeleteRecipes
} from "store/contacts/actions";

import axios from 'axios';

import { Name } from "./EcommerceOrderCol";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader';

//redux
import { useSelector, useDispatch } from "react-redux";
import EcommerceOrdersModal from "./EcommerceOrdersModal";

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Progress,
} from "reactstrap";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

function EcommerceOrder() {
  document.title = "Tarifler | Buhara - Admin Paneli";

  const [getFileNameMobile, setFileNameMobile] = useState(null);
  const [getFileNameLogo, setFileNameLogo] = useState(null);
  const [getProductList, setProductList] = useState([]);
  const [getSelectProduct, setSelectProduct] = useState([]);

  const [getSelectGramList, setSelectGramList] = useState([]);
  const [getGramList, setGramList] = useState([]);
  const [getBlogList, setBlogList] = useState([]);

  const [getIsAddMaking, setIsAddMaking] = useState(false);
  const [getMakingList, setMakingList] = useState([]);
  const [getCountStep, setCountStep] = useState(1);

  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://buharaadmin.stechomeyazilim.info:8099/uploadfile', body }
  }

  const handleChangeStatusLogo = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameLogo(result.file.filename)
        }
      }
    }
  }

  const handleChangeStatusMobile = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameMobile(result.file.filename)
        }
      }
    }
  }

  // --- API ÇAĞRILARI ---
  const _getGramList = async () => {
    try {
      const res = await axios.get(`https://buharaapi.stechomeyazilim.info:5210/getProductsUnit/select/`);
      const mapped = res.data.map(item => ({ label: item.Products_Units_Text, value: item.ID }));
      setGramList(mapped);
    } catch (err) { console.error(err); }
  }

  const _getProductList = async () => {
    try {
      const res = await axios.get(`https://buharaapi.stechomeyazilim.info:5210/getProducts2/select/`);
      const mapped = res.data.map(item => ({ label: item.Products_Name, value: item.ID }));
      setProductList(mapped);
    } catch (err) { console.error(err); }
  }

  const _getBlogList = async () => {
    try {
      const res = await axios.get(`https://buharaapi.stechomeyazilim.info:5210/getBlog/select/`);
      const mapped = res.data.map(item => ({ label: item.Blog_Title, value: item.ID }));
      setBlogList(mapped);
    } catch (err) { console.error(err); }
  }

  useEffect(() => {
    _getProductList();
    _getGramList();
    _getBlogList();
  }, []);

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getMakingText, setMakingText] = useState(null);

  const [orderList, setOrderList] = useState([]);
  const [order, setOrder] = useState(null);
  const [getOrderProduct, setOrderProduct] = useState(null);
  const [getOrderBlog, setOrderBlog] = useState(null);

  const [getEditSlider, setEditSlider] = useState(null);
  const [getIsEditAddProduct, setIsEditAddProduct] = useState(false);
  const [getIsAddBlog, setIsAddBlog] = useState(false);
  const [getSelectBlog, setSelectBlog] = useState([]);
  const [getIsActiveStory, setIsActiveStory] = useState(false);

  const dispatch = useDispatch();
  const { orders } = useSelector(state => ({
    orders: state.contacts.recipesR,
  }));

  useEffect(() => {
    if (orders && !orders.length) {
      dispatch(onGetRecipes());
      setIsEdit(false);
    }
    setOrderList(orders);
  }, [dispatch, orders]);

  // --- ANA FORMIK YAPISI (Tek Seferde Ekleme İçin Geliştirildi) ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      recipesName: (getEditSlider && getEditSlider.Recipes_Title) || '',
      shortDesc: (getEditSlider && getEditSlider.Recipes_ShortText) || '',
      cookingTime: (getEditSlider && getEditSlider.Recipes_Cooking_Time) || '',
      prepationTime: (getEditSlider && getEditSlider.Recipes_Preparation_Time) || '',
      longDesc: (getEditSlider && getEditSlider.Recipes_Desc) || '',
      ingredients: (getEditSlider && getEditSlider.Recipes_Products && getEditSlider.Recipes_Products.length > 0)
        ? getEditSlider.Recipes_Products.map(p => ({
            product_id: p.Products2_ID || p.Product_ID || '',
            amount: p.Products_Unit_Input || ''
          }))
        : [{ product_id: '', amount: '' }],
      steps: (getEditSlider && getEditSlider.Recipes_Making && getEditSlider.Recipes_Making.length > 0)
        ? getEditSlider.Recipes_Making.map(s => s.Recipes_Making_Title)
        : [''],
    },
    validationSchema: Yup.object({
      recipesName: Yup.string().required("Tarif Başlığını Giriniz"),
      longDesc: Yup.string().required("Açıklama alanını doldurunuz"),
    }),
    onSubmit: async (values) => {
      try {
        if (isEdit) {
           // Düzenleme İşlemi (Redux'a paslıyoruz)
           const updateData = {
              ID: order ? order.ID : 0,
              Recipes_Title: values.recipesName,
              Recipes_Desc: values.longDesc,
              Recipes_Image: getFileNameLogo,
              Recipes_Preparation_Time: values.prepationTime ? parseInt(values.prepationTime) : null,
              Recipes_ShortText: values.shortDesc,
              Recipes_Cooking_Time: values.cookingTime ? parseInt(values.cookingTime) : null,
              Recipes_IsStory: getIsActiveStory,
           };
           dispatch(onUpdateRecipes(updateData));
           toastr.success("Ana bilgiler güncellendi. Ürün ve Adım değişiklikleri için tekil modalı kullanın.");
        } else {
            // YENİ KAYIT (Excel Mantığı ile Eşzamanlı Ekleme)
            const newRecipe = {
                Recipes_Title: values.recipesName,
                Recipes_Desc: values.longDesc,
                Recipes_Image: getFileNameLogo,
                Recipes_Preparation_Time: values.prepationTime ? parseInt(values.prepationTime) : null,
                Recipes_ShortText: values.shortDesc,
                Recipes_Cooking_Time: values.cookingTime ? parseInt(values.cookingTime) : null,
                Recipes_IsStory: getIsActiveStory,
            };

            const response = await axios.post(`https://buharaapi.stechomeyazilim.info:5210/addRecipes/insert`, newRecipe);
            const recipeId = response.data.value[0].ID;

            // Malzemeleri Ekle
            for (const ing of values.ingredients) {
              if (ing.product_id && ing.amount) {
                const recipeProduct = {
                  Products2_ID: parseInt(ing.product_id),
                  Recipes_ID: recipeId,
                  Products_Unit_Input: parseFloat(ing.amount),
                };
                await axios.post(`https://buharaapi.stechomeyazilim.info:5210/addRecipesProducts/insert`, recipeProduct);
              }
            }

            // Adımları Ekle
            for (let i = 0; i < values.steps.length; i++) {
              if (values.steps[i].trim() !== "") {
                const stepData = {
                  Recipes_Making_Title: values.steps[i],
                  Recipes_Making_Sort: i + 1,
                  Recipes_ID: recipeId
                };
                await axios.post(`https://buharaapi.stechomeyazilim.info:5210/postRecipesMaking/insert`, stepData);
              }
            }

            toastr.success("Tarif, malzemeler ve adımlarla birlikte başarıyla eklendi!");
            dispatch(onGetRecipes());
        }
        
        validation.resetForm();
        setModal(false);
      } catch (error) {
        console.error("Kayıt hatası:", error);
        toastr.error("Kayıt sırasında bir hata oluştu.");
      }
    },
  });

  const toggleViewModal = () => setModal1(!modal1);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setOrder(null);
      setEditSlider(null);
      setIsEdit(false);
      setFileNameLogo(null);
    } else {
      setModal(true);
    }
  };

  const handleOrderClick = arg => {
    const orderData = arg;
    setEditSlider(orderData)
    setOrder(orderData);
    setIsEdit(true);
    setIsActiveStory(orderData.Recipes_IsStory);
    setFileNameLogo(orderData.Recipes_Image);
    setFileNameMobile(orderData.Recipes_EngImg);
    setModal(true);
  };

const handleOrderClicks = () => {
  // Tablo verisini (orderList) ASLA bozmamalıyız.
  // Sadece yeni eklenecek form için state'leri sıfırlıyoruz:
  setOrder(null);
  setEditSlider(null);
  setIsEdit(false);
  setFileNameLogo(null);
  
  // Modalı aç
  setModal(true);
};
  // --- DİĞER FONKSİYONLAR (Blog/Tekil Güncelleme vs) ---
  const [deleteModal, setDeleteModal] = useState(false);
  const [getMakinModal, setMakinModal] = useState(false);
  const [getMakingDetail, setMakingDetail] = useState(null);
  const [getProductModal, setProductModal] = useState(false);
  const [getProductDetail, setProductDetail] = useState(null);
  const [getProductText, setProductText] = useState(null);
  const [getProductCheck, setProductCheck] = useState(null);

  const onClickDelete = (order) => {
    setOrder(order);
    setDeleteModal(true);
  };
  
  const handleDeleteOrder = () => {
    if (order && order.ID) {
      dispatch(onDeleteRecipes(order.ID));
      setDeleteModal(false);
    }
  };

  const handleRecipesMaking = (item) => {
      setMakinModal(true);
      setMakingDetail(item)
      setMakingText(item.Recipes_Making_Title)
  };

  const handleRecipesProduct = (item) => {
      setProductModal(true);
      setProductDetail(item)
      if(item.Products != null){
        setProductText(item.Products.Products_Name)
        setProductCheck(1)
      }
      if(item.Products2 != null){
        setProductText(item.Products2.Products_Name)
        setProductCheck(2)
      }
  };

  const _deleteRecipesMaking = async() => {
    try{
       await axios.delete(`https://buharaapi.stechomeyazilim.info:5210/deleteRecipesMaking/${getMakingDetail.ID}`);
       dispatch(onGetRecipes());
       setMakinModal(false);
    }catch (err) { console.log(err); }
  }

  const _updateMakingList = async() => {
    try{
       const updateData = { Recipes_Making_Title: getMakingText }
       await axios.patch(`https://buharaapi.stechomeyazilim.info:5210/patchRecipesMaking/${getMakingDetail.ID}`, updateData);
       dispatch(onGetRecipes());
       setMakinModal(false);
    }catch (err) { console.log(err); }
  }

  const _deleteRecipesProduct = async() => {
    try{
       await axios.delete(`https://buharaapi.stechomeyazilim.info:5210/deleteRecipesProduct/${getProductDetail.ID}`);
       dispatch(onGetRecipes());
       setProductModal(false);
    }catch (err) { console.log(err); }
  }

  const _updateProductList = async() => {
    try{
       const updateData = { Products_Name: getProductText }
       if(getProductCheck === 1){
         await axios.patch(`https://buharaapi.stechomeyazilim.info:5210/patchProduct/${getProductDetail.ID}`, updateData);
       }else{
         await axios.patch(`https://buharaapi.stechomeyazilim.info:5210/patchProduct2/${getProductDetail.ID}`, updateData);
       }
       dispatch(onGetRecipes());
       setProductModal(false);
    }catch (err) { console.log(err); }
  }

  // Blog modal logic
  const toggleAddBlog = () => setIsAddBlog(!getIsAddBlog);
  const handleAddBlog = arg => {
    setOrderBlog(arg);
    setSelectBlog([]);
    _getBlogList();
    if(arg.Recipes_Blog && arg.Recipes_Blog.length > 0){
      const currentBlogs = arg.Recipes_Blog.map(item => ({ label: item.Blog.Blog_Title, value: item.Blog.ID }));
      setSelectBlog(currentBlogs);
    }
    setIsAddBlog(true);
  };

  const postBlogInRecipes = async() => {
    try{
      if(getSelectBlog.length > 0){
        for(const item of getSelectBlog){
          let data = { Recipes_ID: getOrderBlog.ID, Blog_ID: item.value }    
          await axios.post(`https://buharaapi.stechomeyazilim.info:5210/postBlogInRecipes/insert`, data);
        }
        dispatch(onGetRecipes());
        toggleAddBlog();
      }else{
        toastr.warning("Blog seçilmedi.");
      }
    }catch (err) { console.log(err); }
  }

  // --- EXCEL YÜKLEME ---
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const arrayBufferToBinaryString = (buffer) => {
    const binaryArray = new Uint8Array(buffer);
    return binaryArray.reduce((data, byte) => data + String.fromCharCode(byte), '');
  };

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
  
      reader.onload = async (event) => {
        setUploadModalOpen(true);
        setUploadProgress(0);
  
        const binaryString = arrayBufferToBinaryString(event.target.result);
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  
        const headers = data[0];
        const formattedData = data.slice(1).map((row) => {
          const rowData = {};
          row.forEach((cell, index) => { rowData[headers[index]] = cell; });
          return rowData;
        });
  
        const existingCodes = new Set(orders.map((user) => user.Recipes_Title));
        const allProductsRes = await axios.get(`https://buharaapi.stechomeyazilim.info:5210/getProducts2/select/`);
        const productListEx = allProductsRes.data;
  
        const total = formattedData.length;
  
        for (let index = 0; index < total; index++) {
          const row = formattedData[index];
          if (existingCodes.has(row.tarifadı)) continue;
  
          try {
            const newRecipe = {
              Recipes_Title: row.tarifadı,
              Recipes_Desc: row.tarifaçıklaması,
              Recipes_Preparation_Time: row.hazırlamasüresi,
              Recipes_Cooking_Time: row.pişirmesüresi,
              Recipes_Category_ID: parseInt(row.katID),
              Recipes_IsStory: false,
              Recipes_Trend: false,
            };
  
            const recipeResponse = await axios.post(`https://buharaapi.stechomeyazilim.info:5210/addRecipes/insert`, newRecipe);
            const recipeId = recipeResponse.data.value[0].ID;
  
            for (let i = 1; i <= 20; i++) {
              const productCode = row[`id${i}`]?.toString();
              const productAmount = parseFloat(row[`miktar${i}`]);
              if (!productCode || isNaN(productAmount)) continue;
  
              const product = productListEx.find(p => p.Products2_Code === productCode);
              if (product) {
                const recipeProduct = {
                  Products2_ID: product.ID,
                  Products_Unit_ID: product.Products_Units_ID,
                  Recipes_ID: recipeId,
                  Products_Unit_Input: productAmount,
                  Recipe_Products_GR: productAmount * parseInt(product.Products_Amount)
                };
                await axios.post(`https://buharaapi.stechomeyazilim.info:5210/addRecipesProducts/insert`, recipeProduct);
              }
            }
  
            for (let i = 1; i <= 11; i++) {
              const stepText = row[i.toString()];
              if (stepText && stepText !== "") {
                const step = {
                  Recipes_Making_Title: stepText.toString(),
                  Recipes_Making_Sort: i,
                  Recipes_ID: recipeId
                };
                await axios.post(`https://buharaapi.stechomeyazilim.info:5210/postRecipesMaking/insert`, step);
              }
            }
            setUploadProgress(Math.round(((index + 1) / total) * 100));
          } catch (err) { console.error("Tarif eklenirken hata:", err); }
        }
        setUploadModalOpen(false);
        dispatch(onGetRecipes());
      };
      reader.readAsArrayBuffer(file);
    } catch (err) { console.log(err); }
  };

  const handleClick = () => document.getElementById('fileInput').click();

  const columns = useMemo(
    () => [
      {
        Header: "Tarif Görseli",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Recipes_Image ? (
              <div className="avatar-xl">
               {cellProps.Recipes_Title != null ? <span className="avatar-title rounded-circle">{cellProps.Recipes_Title.charAt(0)}</span> : null}
              </div>
            ) : (
              <div><img className=" avatar-xl" src={'https://buharasubdomain.stechomeyazilim.info/' +  cellProps.Recipes_Image} alt="" /></div>
            )}
          </>
        ),
      },
      { Header: 'Tarif Adı', accessor: 'Recipes_Title', disableFilters: true, filterable: true, Cell: (cellProps) => <Name {...cellProps} /> },
      { Header: 'Tarif Açıklama', accessor: 'Recipes_Desc', disableFilters: true, filterable: true, Cell: (cellProps) => <Name {...cellProps} /> },
      {
        Header: 'İşlemler',
        accessor: 'action',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link to="#" className="text-danger" onClick={() => handleAddBlog(cellProps.row.original)}>Blog Ekle</Link>
              <Link to="#" className="text-success" onClick={() => handleOrderClick(cellProps.row.original)}>
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">Düzenle</UncontrolledTooltip>
              </Link>
              <Link to="#" className="text-danger" onClick={() => onClickDelete(cellProps.row.original)}>
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">Sil</UncontrolledTooltip>
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} alt="" /> <span className="name">{name}</span> - <span className="status">{status === "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)} />

      <Modal isOpen={uploadModalOpen} backdrop="static" centered>
        <ModalBody>
          <p className="text-center text-lg font-bold mb-3">Yükleme Devam Ediyor...</p>
          <Progress value={uploadProgress} color="warning" animated />
          <p className="text-center mt-2">{uploadProgress}%</p>
        </ModalBody>
      </Modal>

      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Yönetim" breadcrumbItem="Tarifler" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <button color="success" className="btn-rounded mb-2 me-2" onClick={handleClick}>Excel Dosyasını Yükle</button>
                  <input id="fileInput" type="file" accept=".xlsx, .xls" style={{ display: 'none' }} onChange={handleFileUpload} />
                  <TableContainer
                    columns={columns}
                    data={orderList}
                    isGlobalFilter={true}
                    isAddRecipes={true}
                    handleOrderClicks={handleOrderClicks}
                    customPageSize={10}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* ANA EKLEME/DÜZENLEME MODALI */}
          <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Tarifi Düzenle" : "Tarif Ekle"}
            </ModalHeader>
            <ModalBody style={{ maxHeight: '75vh', overflowY: 'auto' }}>
              <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                
                {/* 1. TARİF TEMEL BİLGİLERİ */}
                <h5 className="mb-3 text-primary">Temel Bilgiler</h5>
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label">Tarif Adı</Label>
                      <Input name="recipesName" type="text" placeholder="Tarif Adı" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.recipesName || ""} invalid={validation.touched.recipesName && validation.errors.recipesName ? true : false} />
                      {validation.touched.recipesName && validation.errors.recipesName ? (<FormFeedback type="invalid">{validation.errors.recipesName}</FormFeedback>) : null}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label">Kısa Açıklama</Label>
                      <Input name="shortDesc" type="text" placeholder="Kısa Açıklama" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.shortDesc || ""} />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="mb-3">
                      <Label className="form-label">Detaylı Açıklama</Label>
                      <Input name="longDesc" type="textarea" rows="3" placeholder="Detaylı Açıklama" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.longDesc || ""} invalid={validation.touched.longDesc && validation.errors.longDesc ? true : false} />
                      {validation.touched.longDesc && validation.errors.longDesc ? (<FormFeedback type="invalid">{validation.errors.longDesc}</FormFeedback>) : null}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label">Hazırlama Süresi (Dk)</Label>
                      <Input name="prepationTime" type="number" placeholder="Örn: 15" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.prepationTime || ""} />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label">Pişirme Süresi (Dk)</Label>
                      <Input name="cookingTime" type="number" placeholder="Örn: 30" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.cookingTime || ""} />
                    </div>
                  </Col>
                </Row>

                {/* 2. MALZEMELER */}
                <hr />
                <h5 className="mb-3 text-primary">Malzemeler</h5>
                {validation.values.ingredients.map((ingredient, index) => (
                  <Row key={index} className="mb-2 align-items-center">
                    <Col md={7}>
                      <select className="form-select" value={ingredient.product_id} onChange={(e) => {
                          const newIng = [...validation.values.ingredients];
                          newIng[index].product_id = e.target.value;
                          validation.setFieldValue("ingredients", newIng);
                        }}>
                        <option value="">Ürün Seçiniz...</option>
                        {getProductList?.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                      </select>
                    </Col>
                    <Col md={3}>
                      <Input type="number" placeholder="Miktar" value={ingredient.amount} onChange={(e) => {
                          const newIng = [...validation.values.ingredients];
                          newIng[index].amount = e.target.value;
                          validation.setFieldValue("ingredients", newIng);
                        }} />
                    </Col>
                    <Col md={2}>
                      <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => {
                        const newIng = validation.values.ingredients.filter((_, i) => i !== index);
                        validation.setFieldValue("ingredients", newIng);
                      }}>Kaldır</button>
                    </Col>
                  </Row>
                ))}
                <button type="button" className="btn btn-soft-success btn-sm mb-4 mt-2" onClick={() => {
                  validation.setFieldValue("ingredients", [...validation.values.ingredients, { product_id: '', amount: '' }]);
                }}>+ Malzeme Ekle</button>

                {/* 3. HAZIRLANIŞ ADIMLARI */}
                <hr />
                <h5 className="mb-3 text-primary">Hazırlanış Adımları</h5>
                {validation.values.steps.map((step, index) => (
                  <div key={index} className="d-flex mb-3 align-items-start">
                    <span className="me-3 mt-2 fw-bold">{index + 1}.</span>
                    <Input type="textarea" rows="2" value={step} placeholder="Adım detayını yazınız..." onChange={(e) => {
                        const newSteps = [...validation.values.steps];
                        newSteps[index] = e.target.value;
                        validation.setFieldValue("steps", newSteps);
                      }} />
                    <button type="button" className="btn btn-link text-danger ms-2" onClick={() => {
                      const newSteps = validation.values.steps.filter((_, i) => i !== index);
                      validation.setFieldValue("steps", newSteps);
                    }}>Kaldır</button>
                  </div>
                ))}
                <button type="button" className="btn btn-soft-success btn-sm mb-4" onClick={() => {
                  validation.setFieldValue("steps", [...validation.values.steps, '']);
                }}>+ Adım Ekle</button>

                {/* 4. GÖRSEL VE DİĞER AYARLAR */}
                <hr />
                <h5 className="mb-3 text-primary">Görseller ve Ayarlar</h5>
                <Row>
                  <Col md={6}>
                    <Label className="form-label">Hikayede Görüntülensin Mi?</Label>
                    <div className="square-switch mb-3">
                      <input type="checkbox" id="square-switch1" className="switch" checked={getIsActiveStory} onChange={() => setIsActiveStory(!getIsActiveStory)} />
                      <label htmlFor="square-switch1" data-on-label="Evet" data-off-label="Hayır" />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className="mb-4">
                    <label>Tarif Görseli (800x600)</label>
                    <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatusLogo} maxFiles={1}
                      styles={{ dropzone: { overflow: 'auto', border: '1px dashed #999', background: '#f8f9fa' } }}
                      canRemove={false} PreviewComponent={Preview} accept="image/*" />
                    {getFileNameLogo && (
                      <div className="mt-2"><img className="rounded shadow-sm" style={{maxHeight:'100px'}} src={'https://buharasubdomain.stechomeyazilim.info/' + getFileNameLogo} alt="Mevcut Görsel" /></div>
                    )}
                  </Col>
                </Row>

                <div className="text-end pt-3 border-top">
                  <button type="button" className="btn btn-light me-2" onClick={toggle}>İptal</button>
                  <button type="submit" className="btn btn-success">
                     {isEdit ? "Değişiklikleri Kaydet" : "Tümünü Kaydet (Tarif + Ürünler + Adımlar)"}
                  </button>
                </div>
              </Form>
            </ModalBody>
          </Modal>

          {/* DİĞER TEKİL DÜZENLEME MODALLARI (SİLİNMEYİP KORUNDU) */}
          <Modal isOpen={getIsAddBlog} toggle={toggleAddBlog}>
            <ModalHeader toggle={toggleAddBlog} tag="h4">Blog Ekle</ModalHeader>
            <ModalBody>
              <Form onSubmit={(e) => { e.preventDefault(); postBlogInRecipes(); }}>
                <MultiSelectOption handleChange={(val) => setSelectBlog(val)} fullData={getBlogList} value={getSelectBlog} type={"blog"} />
                <div className="text-end mt-3"><button type="submit" className="btn btn-success">Kaydet</button></div>
              </Form>
            </ModalBody>
          </Modal>
          
        </div>
      </div>
    </React.Fragment>
  );
}

EcommerceOrder.propTypes = { preGlobalFilteredRows: PropTypes.any };
export default EcommerceOrder;